import * as d3 from 'd3'
import { judge_value_valid } from '@/utils/chart/verification.js'

export const draw_cross = (svg, {data, height, margin, scale_data, scale_y}) => {
    const CROSS_ENLARGE_SIZE = 4
    svg.selectAll('cross')
        .data(
            data
            .map((d, i) => ({ d, i }))
            .filter(({ d }) => !judge_value_valid(d))
        )
        .enter()
        .append('path')
        .attr('d', d3
            .symbol()
            .size(scale_data(1) * CROSS_ENLARGE_SIZE)
            .type(d3.symbolCross)
        )
        .attr('class', 'cross')
        .attr('fill', 'red')
        .attr('transform', ({d, i}) => {
            return `translate(${margin.left + scale_data(i)}, ${judge_value_valid(d) ? scale_y(d) : height}) rotate(45)`
        })
}

export const draw_cross_legend = (svg) => {
    return svg.append('path')
        .attr('d', d3
            .symbol()
            .size(128)
            .type(d3.symbolCross)
        )
        .attr('class', 'cross')
        .attr('fill', 'red')
}

export const draw_triangle = (svg, options) => {
    const { margin, scale_data, scale_y, tooltip }  = options.common
    const { color, label_distance, rotate_deg, index, value, datetime } = options.detail
    const { 
        text: tooltip_text, 
        unit: tooltip_unit 
    } = tooltip
    
    const triangle = d3.symbol()
        .type(d3.symbolTriangle)
        .size(150)

    svg.append('path')
        .attr('d', triangle)
        .attr('fill', color)
        .attr('transform', `translate(${margin.left + scale_data(index)}, ${scale_y(value)+ label_distance}) rotate(${rotate_deg})`)
        .on('mouseover', () => {
            tooltip
                .transition()
                .duration(200)
                .style('opacity', 0.9)
            tooltip
                .html(`
                    ${datetime}
                    </br>
                    ${tooltip_text}: ${parseFloat(value)} ${tooltip_unit}
                `)
                .style('left', `${d3.event.clientX}px`)
                .style('top', `${d3.event.offsetY + 60}px`)
                .style('transform', `translate(-50%, -100%)`) 
        })
        .on('mouseout', () => {
            tooltip.transition()
                .duration(500)
                .style('opacity', 0);
        })
}

export const draw_triangle_text = (svg, options) => {
    const { margin, scale_data, scale_y }  = options.common
    const { color, index, value, label_value_distance } = options.detail

    svg.append('text')
        .attr('x', margin.left + scale_data(index))
        .attr('y', scale_y(value) + label_value_distance)
        .attr('text-anchor', 'middle')
        .style('text-decoration', 'underline')  
        .style('stroke', color)
        .style('opacity', 0.75)
        .text(value)
}